import { render } from "./index.vue?vue&type=template&id=2efb21de&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2efb21de&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efb21de"],['__file',"src/views/404/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2efb21de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2efb21de', __exports__)) {
    console.log('reload')
    api.reload('2efb21de', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2efb21de&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2efb21de', render)
  })

}


export default __exports__